import { addDays } from 'date-fns';

/**
 * How far ahead a hire date may be set (VTK-1953 review).
 *
 * Hiring ahead of a start date is normal; next year is a typo. The server bounds the same window
 * (`IsPlausibleHireDate`) and is what enforces it — this exists so the pickers and the client-side
 * schemas cannot drift from each other, or from it.
 *
 * It replaces three separate hard-coded `60`s that did not even agree. Section 2's Step 1 picker used
 * `new Date(year, month + 1, 60)` — 60 days after the FIRST OF NEXT MONTH, so 60 + (days left in the
 * current month), i.e. 61–91 days out and drifting with the calendar. It therefore offered dates the
 * schema went on to reject, by an amount that changed depending on when you looked.
 * `hireDateCeiling()` is the one arithmetic.
 */
export const HIRE_DATE_MAX_DAYS_AHEAD = 60;

/** The latest date a hire-date picker should offer. */
export const hireDateCeiling = (from: Date = new Date()): Date =>
  addDays(from, HIRE_DATE_MAX_DAYS_AHEAD);
